export const MYEYEDR_WEBSITE_URL = "https://www.myeyedr.com";
export const MYEYEDR_VIDEO_ASSISTED_EYE_HEALTH_URL =
  "https://www.myeyedr.com/video-assisted-eye-health";
export const MYEYEDR_MAINTENANCE_PHONE_NUMBER = "1-866-693-9336";
